import { PluginObject } from 'vue/types/plugin';
import { install, InstallOptions } from './install';

export const AngieUI: PluginObject<InstallOptions> = {
    install,
};
